// SVG Decorative elements for the website

// Grid Pattern SVG Background
export const GridPatternSVG = ({ className = "" }) => (
  <svg
    className={className}
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <pattern
        id="grid-pattern"
        width="50"
        height="50"
        patternUnits="userSpaceOnUse"
      >
        <path
          d="M 50 0 L 0 0 0 50"
          fill="none"
          stroke="currentColor"
          strokeWidth="0.5"
          opacity="0.1"
        />
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#grid-pattern)" />
  </svg>
);

// Blueprint Dashed Lines
export const BlueprintLinesSVG = ({ className = "" }) => (
  <svg
    className={className}
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <pattern
        id="blueprint-lines"
        width="100"
        height="100"
        patternUnits="userSpaceOnUse"
      >
        <line
          x1="0"
          y1="50"
          x2="100"
          y2="50"
          stroke="currentColor"
          strokeWidth="0.5"
          strokeDasharray="5,5"
          opacity="0.15"
        />
        <line
          x1="50"
          y1="0"
          x2="50"
          y2="100"
          stroke="currentColor"
          strokeWidth="0.5"
          strokeDasharray="5,5"
          opacity="0.15"
        />
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#blueprint-lines)" />
  </svg>
);

// Construction/Building Abstract Shape
export const ConstructionShapeSVG = ({ className = "", color = "#F97316" }) => (
  <svg
    className={className}
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="20" y="60" width="40" height="120" fill={color} opacity="0.1" />
    <rect x="70" y="30" width="50" height="150" fill={color} opacity="0.15" />
    <rect x="130" y="80" width="35" height="100" fill={color} opacity="0.1" />
    <rect x="10" y="180" width="180" height="8" fill={color} opacity="0.2" />
  </svg>
);

// Triangle/Structural Shape
export const StructuralTriangleSVG = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polygon
      points="50,10 90,90 10,90"
      stroke="#0F172A"
      strokeWidth="2"
      fill="none"
      opacity="0.1"
    />
    <line
      x1="50"
      y1="10"
      x2="50"
      y2="90"
      stroke="#0F172A"
      strokeWidth="1"
      opacity="0.1"
    />
    <line
      x1="30"
      y1="50"
      x2="70"
      y2="50"
      stroke="#0F172A"
      strokeWidth="1"
      opacity="0.1"
    />
  </svg>
);

// Dot Matrix Pattern
export const DotMatrixSVG = ({ className = "" }) => (
  <svg
    className={className}
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <pattern
        id="dot-matrix"
        width="20"
        height="20"
        patternUnits="userSpaceOnUse"
      >
        <circle cx="2" cy="2" r="1" fill="currentColor" opacity="0.15" />
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#dot-matrix)" />
  </svg>
);

// Decorative Corner Element
export const CornerElementSVG = ({ className = "", position = "top-left" }) => {
  const transforms = {
    "top-left": "",
    "top-right": "scale(-1, 1)",
    "bottom-left": "scale(1, -1)",
    "bottom-right": "scale(-1, -1)",
  };

  return (
    <svg
      className={className}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: transforms[position] }}
    >
      <path
        d="M0 0 L40 0 L40 5 L5 5 L5 40 L0 40 Z"
        fill="#F97316"
        opacity="0.3"
      />
      <path
        d="M0 0 L20 0 L20 2 L2 2 L2 20 L0 20 Z"
        fill="#0F172A"
        opacity="0.5"
      />
    </svg>
  );
};

// Section Divider
export const SectionDividerSVG = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 1200 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <line
      x1="0"
      y1="10"
      x2="550"
      y2="10"
      stroke="url(#divider-gradient-left)"
      strokeWidth="1"
    />
    <rect x="560" y="5" width="80" height="10" fill="#F97316" />
    <line
      x1="650"
      y1="10"
      x2="1200"
      y2="10"
      stroke="url(#divider-gradient-right)"
      strokeWidth="1"
    />
    <defs>
      <linearGradient id="divider-gradient-left" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#0F172A" stopOpacity="0" />
        <stop offset="100%" stopColor="#0F172A" stopOpacity="0.2" />
      </linearGradient>
      <linearGradient id="divider-gradient-right" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#0F172A" stopOpacity="0.2" />
        <stop offset="100%" stopColor="#0F172A" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default {
  GridPatternSVG,
  BlueprintLinesSVG,
  ConstructionShapeSVG,
  StructuralTriangleSVG,
  DotMatrixSVG,
  CornerElementSVG,
  SectionDividerSVG,
};
